import { Auditable, QueryParams, SortParams } from "..";

export interface AccountType extends Auditable {
    name: string;
}

export const DefaultAccountTypeQueryParams: QueryParams = {
    name: "",
};

export const DefaultAccountTypeSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
